export const RatingWorkflowTableHeader = [
  {
    line1: "WF.08",
    line2: "Previous Status",
    line3: null,
    key: "changedInspStatus",
    sortable: false,
  },
  {
    line1: "WF.06",
    line2: "User Name",
    line3: null,
    key: "updateUserId",
    sortable: false,
  },
  {
    line1: "WF.09",
    line2: "Updated Status",
    line3: null,
    key: "newInspStatus",
    sortable: false,
  },
  {
    line1: "WF.07",
    line2: "Update Date/Time",
    line3: null,
    key: "updateDateTime",
    sortable: false,
  },
];

export const MaintenanceWorkflowTableHeader = [
  {
    line1: "WF.05",
    line2: "Field #",
    line3: null,
    key: "columnName",
    sortable: false,
  },
  {
    line1: "WF.06",
    line2: "User Name",
    line3: null,
    key: "updateUserId",
    sortable: false,
  },
  {
    line1: "WF.07",
    line2: "Update Date/Time",
    line3: null,
    key: "updateDateTime",
    sortable: false,
  },
];
const commonHeaders = [
  {
    line1: "B.ID.01",
    line2: "BRKEY",
    line3: null,
    key: "brkey",
    sortable: true,
  },
  {
    line1: "ID.01",
    line2: "BMS ID",
    line3: null,
    key: "bmsId",
    sortable: true,
  },
  {
    line1: "B.L.04",
    line2: "District",
    line3: null,
    key: "district",
    sortable: true,
  },
  {
    line1: "B.CL.01",
    line2: "Owner",
    line3: null,
    key: "owner__formatted__",
    sortable: true,
  },
];
const dateSort = (a, b) => new Date(a) - new Date(b);
export const InspectionReviewTableHeader = [
  ...commonHeaders,
  {
    line1: "ID.02",
    line2: "Rpt Grp",
    line3: null,
    key: "reportGroup",
    sortable: true,
  },
  {
    line1: "IE.05",
    line2: "Insp",
    line3: "Start Date",
    key: "inspectionDate__formatted__",
    sortable: true,
    sort: dateSort,
  },
  {
    line1: "IE.06",
    line2: "Insp",
    line3: "End Date",
    key: "overallEndDate__formatted__",
    sortable: true,
    sort: dateSort,
  },
  {
    line1: "IE.34",
    line2: "Insp Status",
    line3: null,
    key: "inspectionStatus__formatted__",
    sortable: true,
  },
  {
    line1: "WF.01",
    line2: "P0/P1",
    line3: "Maint Item",
    key: "p0p1MaintItem__formatted__",
    sortable: true,
  },
  {
    line1: "B.C.13",
    line2: "Low",
    line3: "Cond Rating",
    key: "lowestCondition",
    sortable: true,
  },
  {
    line1: "WF.02",
    line2: "Element",
    line3: "in CS4",
    key: "elementInCs4__formatted__",
    sortable: true,
  },
  {
    line1: "WF.03",
    line2: "Inspection Review",
    line3: "Assigned to",
    key: "approverUserId",
    sortable: true,
  },
];

export const MaintenanceItemPOATableHeader = [
  ...commonHeaders,
  {
    line1: "M.05",
    line2: "Priority",
    line3: null,
    key: "agencyPriority__formatted__",
    sortable: true,
  },
  {
    line1: "M.02",
    line2: "Action",
    line3: null,
    key: "actCode__formatted__",
    sortable: true,
  },
  {
    line1: "M.07",
    line2: "Date",
    line3: "Recommend",
    key: "workRecDate__formatted__",
    sortable: true,
    sort: dateSort,
  },
  {
    line1: "M.14 POA",
    line2: "Date",
    line3: null,
    key: "poaDate__formatted__",
    sortable: true,
    sort: dateSort,
  },
  {
    line1: "M.20 Bridge",
    line2: "Appr",
    line3: null,
    key: "bridgeApproval",
    sortable: true,
  },
  {
    line1: "M.21 Maint",
    line2: "Appr",
    line3: null,
    key: "maintApproval",
    sortable: true,
  },
];

export const BPRReviewsTableHeader = [
  ...commonHeaders,
  {
    line1: "BPR.02",
    line2: "BPR",
    line3: "Number",
    key: "bprId",
    sortable: true,
  },
  {
    line1: "BPR.04",
    line2: "BPR",
    line3: "Date",
    key: "reportedOn__formatted__",
    sortable: true,
    sort: dateSort,
  },
  {
    line1: "BPR.05",
    line2: "BPR Status",
    line3: null,
    key: "bprStatus__formatted__",
    sortable: true,
  },
  {
    line1: "BPR.01",
    line2: "Reported By",
    line3: null,
    key: "reportedBy",
    sortable: true,
  },
  {
    line1: "BPR.06",
    line2: "Finalized By",
    line3: null,
    key: "finalizedBy",
    sortable: true,
  },
];

export const LoadRatingReviewsTableHeader = [
  ...commonHeaders,
  {
    line1: "ID.02",
    line2: "Rpt",
    line3: "Grp",
    key: "reportGroup",
    sortable: true,
  },
  {
    line1: "IE.05",
    line2: "Insp",
    line3: "Start Date",
    key: "inspectionDate__formatted__",
    sortable: true,
    sort: dateSort,
  },
  {
    line1: "IE.06",
    line2: "Insp",
    line3: "End Date",
    key: "overallEndDate__formatted__",
    sortable: true,
    sort: dateSort,
  },
  {
    line1: "Inspection Team Comments",
    line2: null,
    line3: null,
    key: "inspectionTeamComment",
    sortable: true,
    width: "30%",
  },
  {
    line1: "LR.01",
    line2: null,
    line3: null,
    key: "recommendRatingReview",
    sortable: true,
  },
  {
    line1: "LR.02",
    line2: null,
    line3: null,
    key: "lrReviewAction__formatted__",
    sortable: true,
  },
];
